// Venue names as an English reader would recognise them, keyed by the name as published.
// Only the listing uses these: the detail page keeps the venue exactly as it is cited, because
// that is the name the work is indexed under. Venues already in English are absent by design.
export const venueTranslations = {
  "Anais do XXVI Simpósio Brasileiro de Cibersegurança":
    "Proceedings of the XXVI Brazilian Symposium on Cybersecurity",
  "Anais Estendidos do XXVI Simpósio Brasileiro de Cibersegurança":
    "Extended Proceedings of the XXVI Brazilian Symposium on Cybersecurity",
  "Anais Estendidos do XXV Simpósio Brasileiro de Cibersegurança":
    "Extended Proceedings of the XXV Brazilian Symposium on Cybersecurity",
  "Anais Estendidos do XXIII Simpósio Brasileiro de Segurança da Informação e de Sistemas Computacionais":
    "Extended Proceedings of the XXIII Brazilian Symposium on Information and Computational Systems Security",
  "Anais da XII Escola Regional de Alto Desempenho da Região Sul":
    "Proceedings of the XII Southern Regional School of High Performance Computing",
  "Anais da III Mostra de Ensino, Pesquisa e Extensão do IFRS Campus Rolante":
    "Proceedings of the III Teaching, Research and Outreach Showcase of IFRS Campus Rolante",
  "Anais da IV Mostra de Ensino, Pesquisa e Extensão do IFRS Campus Rolante":
    "Proceedings of the IV Teaching, Research and Outreach Showcase of IFRS Campus Rolante",
  "Anais da Academia Brasileira de Ciências": "Annals of the Brazilian Academy of Sciences",
  "Revista Brasileira de Geografia Física": "Brazilian Journal of Physical Geography",
  "Rede Nacional de Ensino e Pesquisa (RNP)": "Brazilian National Research and Education Network (RNP)",
  "Universidade Federal de Santa Catarina": "Federal University of Santa Catarina",
  "Universidade Federal do Rio Grande do Sul": "Federal University of Rio Grande do Sul",
  "Universidade do Vale do Rio dos Sinos": "University of Vale do Rio dos Sinos",
  "Escola Estadual de Educação Profissional em Estrela": "Estrela State School of Professional Education",

  // Talks
  "Workshop Acadêmico do Registro Civil": "Civil Registry Academic Workshop",
  "V Mostra de Ensino, Pesquisa e Extensão": "V Teaching, Research and Outreach Showcase",
  "22ª Workshop RNP": "22nd RNP Workshop",
  "27° Workshop RNP": "27th RNP Workshop",
  "Fórum RNP 2026": "RNP Forum 2026",
  "Reunião semanal do LabSEC": "LabSEC weekly meeting",
  "Reunião Grupo de Interesse Especial em Gestão de Identidade Digital (SIG-GId)":
    "Meeting of the Special Interest Group on Digital Identity Management (SIG-GId)",
  "1ª reunião de 2022 do CT-GId - Comitê Técnico de Gestão de Identidade":
    "1st 2022 meeting of CT-GId, the Identity Management Technical Committee",
  "6ª reunião de 2025 do CT-GId - Comitê Técnico de Gestão de Identidade":
    "6th 2025 meeting of CT-GId, the Identity Management Technical Committee",
  "9ª reunião de 2025 do CT-GId - Comitê Técnico de Gestão de Identidade":
    "9th 2025 meeting of CT-GId, the Identity Management Technical Committee",
  "Encontro presencial do CT-GId": "In-person meeting of CT-GId",
  "Fórum Nacional de Governação da Internet 2025": "National Internet Governance Forum 2025",
};

export const translateVenue = (name, isPortuguese) =>
  isPortuguese ? name : (venueTranslations[name] || name);
